import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../store/reducers/rootReducer'
import { LOAD, LOAD_END } from '../../../store/actions/actionsTypes'



const usePrint = () => {
  const dispatch = useDispatch()
  const token = useSelector((state: RootState) => state.mainReducer.token)
  const [file, setFile] = useState<Blob | null>(null)
  const [pdfAsFile, setPdfAsFile] = useState<File | null>(null)
  const handleGetPdf = async (url: string): Promise<File | null> => { 
    console.log("url", `https://my.agroline.co.il/${url}`)
    try {
      dispatch({type: LOAD})
        let response = await fetch(
            `https://my.agroline.co.il/${url}`,
            {
              headers: {
                Authorization: "Bearer " + token,
              },
            }
          );
          const data = await response.blob();
          // Receive PDF Steam as as Blob
          const file = new Blob([data], { type: "application/pdf" }); //Create a Blob from the PDF Stream
          const filePDF = new File([file], `${new Date().toLocaleDateString()}.pdf`, { type: "application/pdf" })
          setPdfAsFile(filePDF)
          
          setFile(file)
          return filePDF
    } catch {
      return null
    } finally {
        dispatch({type: LOAD_END})
    }

  }

  const handleSharePdf = async (fileName?: string) => {
    if (!file) return
    if (!pdfAsFile) return
    const pdfName = fileName || `${new Date().toLocaleDateString()}.pdf`
    const url = URL.createObjectURL(file)

    // web share API
    if(typeof navigator !== "undefined" && "share" in navigator) {
      const isAllowToShareFile = typeof navigator.canShare === "function"
      ? navigator.canShare({ files: [pdfAsFile] })
      : false;

      try {
        if(isAllowToShareFile) {
          await navigator.share({
            files: [pdfAsFile],
            title: pdfName,
          })
          return 'shared-native-file'
        }
        // if not allow to share file, share the link
        await navigator.share({
          url: url,
          title: pdfName,
        })
        return 'shared-link'
        
      } catch (error) {
        console.error("navigetor.share error", error)
      }
    }

    // fallback to open the file in a new tab or download the file
    window.open(url, '_blank', 'noopener,noreferrer')
    return 'shared-link'

  }

  const handleDownloadPdf = async (fileName?: string) => {
    if (!file) return
    const link = document.createElement("a");
    link.href = URL.createObjectURL(file);
    link.download = `${new Date().toLocaleDateString()}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(link.href), 30_000);
  }

  const handleOpenPdf = (PDF_FILE?: File) => {
    const target = PDF_FILE ?? file
    if (!target) return
    const url = URL.createObjectURL(target)
    const a = document.createElement('a')
    a.href = url
    a.target = '_blank'
    a.rel = 'noopener noreferrer'
    document.body.appendChild(a)
    a.click()
    a.remove()
    setTimeout(() => URL.revokeObjectURL(url), 30_000)
  }
  const handleClearFile = () => {
    setFile(null)
  }

  const setPdfFromBlob = (blob: Blob, fileName?: string) => {
    const pdfBlob = new Blob([blob], { type: 'application/pdf' })
    const name = fileName || `${new Date().toLocaleDateString()}.pdf`
    const filePDF = new File([pdfBlob], name, { type: 'application/pdf' })
    setPdfAsFile(filePDF)
    setFile(pdfBlob)
  }

  return {
    handleGetPdf,
    handleSharePdf,
    file,
    handleDownloadPdf,
    handleClearFile,
    handleOpenPdf,
    setPdfFromBlob,
  }
}

export default usePrint